import {NotiThumbnailType} from '../../../design-system/organisms/NotificationItem/NotiThumbnailType.enum';
import {Maybe, NotiType} from '../../../graphql/generated/types';

/**
 * 알림 아이템에서 보여줄 디폴트 썸네일 이미지 타입을 리턴해주는 함수입니다.
 */
export function getNotiThumbnailType(
  logName?: Maybe<string>
): NotiThumbnailType {
  if (!logName) {
    return NotiThumbnailType.Default;
  }
  switch (logName) {
    case NotiType.Award:
      return NotiThumbnailType.Gift;
    case NotiType.Like:
      return NotiThumbnailType.Heart;
    case NotiType.Reply:
      return NotiThumbnailType.Comment;
    case NotiType.Cash:
      return NotiThumbnailType.Cash;
    case NotiType.Update:
    case NotiType.Ticket:
      return NotiThumbnailType.ProductThumbnail;
    case NotiType.Marketing:
      return NotiThumbnailType.ThumbnailOrDefault;
    default:
      return NotiThumbnailType.Default;
  }
}
